var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { hashKey } from '../../../infra/api/utils';
export var queryKeys = {
    allCampaigns: function () { return ['campaigns']; },
    promoCodesByOwner: function (ownerType, ownerId) {
        return ['promoCodes', ownerType, ownerId];
    },
    automatedCampaignsByOwner: function (ownerType, ownerId) {
        return ['automated-campaigns', ownerType, ownerId];
    },
    campaignsByOwnerFiltersV1: function (ownerType, ownerId, perPage, page, type, status, sortBy, search, creatorIds) {
        return [
            'campaigns',
            ownerType,
            ownerId,
            // eslint-disable-next-line max-len
            "page:".concat(page, "-size:").concat(perPage, "-type:").concat(type, "-status:").concat(status, "-sortBy:").concat(sortBy, "-search:").concat(search, "-creatorIds:").concat(creatorIds),
        ];
    },
    campaignsByOwner: function (ownerType, ownerId, perPage, page, type, status, sortBy, search, creatorIds) {
        return [
            'campaigns',
            ownerType,
            ownerId,
            "page:".concat(page, "-size:").concat(perPage, "-type:").concat(type === null || type === void 0 ? void 0 : type.join(','), "-status:").concat(status === null || status === void 0 ? void 0 : status.join(','), "-sortBy:").concat(sortBy, "-search:").concat(search, "-creatorIds:").concat(creatorIds === null || creatorIds === void 0 ? void 0 : creatorIds.join(',')),
        ];
    },
    campaignFiltersByShop: function (shopId) {
        return ['campaignFilters', 'shop', shopId];
    },
    campaignById: function (campaignId) { return ['campaigns', campaignId]; },
    allCustomerGroups: function () { return ['customerGroups']; },
    customerGroupsByParams: function (params) { return __spreadArray(__spreadArray([], queryKeys.allCustomerGroups(), true), [
        params.ownerType,
        params.ownerId,
        params.newCustomerWeeks,
        params.sendEmail,
        params.sendPush,
        params.sendSms,
    ], false); },
    allClientsByChannel: function () { return ['clientsByChannel']; },
    clientsByChannel: function (params) { return __spreadArray(__spreadArray([], queryKeys.allClientsByChannel(), true), [
        params.ownerType,
        params.ownerId,
        hashKey(params.customerGroups),
    ], false); },
    allAudienceSegments: function () { return ['audienceSegments']; },
    audienceSegmentsByParams: function (params) { return __spreadArray(__spreadArray([], queryKeys.allAudienceSegments(), true), [
        params.ownerType,
        params.ownerId,
        params.newCustomerWeeks,
        params.sms,
        params.email,
        params.push,
    ], false); },
    allCampaignsHtml: function () { return ['campaignsHtml']; },
    campaignHtmlById: function (campaignId) { return __spreadArray(__spreadArray([], queryKeys.allCampaignsHtml(), true), [campaignId], false); },
    allCampaignsMetadata: function () { return ['campaignsMetadata']; },
    campaignMetadataById: function (campaignId) { return __spreadArray(__spreadArray([], queryKeys.allCampaignsMetadata(), true), [campaignId], false); },
};
